import { render, staticRenderFns } from "./crearItem.vue?vue&type=template&id=ab85c022"
import script from "./crearItem.vue?vue&type=script&lang=js"
export * from "./crearItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports